import { render, staticRenderFns } from "./SpecialGifts.vue?vue&type=template&id=a311ac30&scoped=true&"
import script from "./SpecialGifts.vue?vue&type=script&lang=js&"
export * from "./SpecialGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a311ac30",
  null
  
)

export default component.exports